import { render, staticRenderFns } from "./PropostaView.vue?vue&type=template&id=a3c18128&scoped=true"
import script from "./PropostaView.vue?vue&type=script&lang=js"
export * from "./PropostaView.vue?vue&type=script&lang=js"
import style0 from "./PropostaView.vue?vue&type=style&index=0&id=a3c18128&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a3c18128",
  null
  
)

export default component.exports